import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { UseMutateFunction } from "@tanstack/react-query";

import { PaginationWithLimit } from "../index";
import { IPaginationState } from "../../../hooks/usePagination";
import TableData, { INote } from "./TableData";

type TProps = {
  pagination: IPaginationState;
  saveNote: (note: string) => Promise<void>;
  notes: INote[];
  handleDeleteNote: (noteId: number) => Promise<void>;
  handleChangeStatus: (noteId: number, isActive: boolean) => Promise<void>;
  isAllowedChangeStatusAndRemoveActions?: boolean;
};

export const adaptSaveNoteToReactQuery = async <T,>(
  note: T,
  handleCreateNote: UseMutateFunction<void, unknown, T, unknown>
): Promise<void> => {
  return new Promise((resolve, reject) => {
    handleCreateNote(note, {
      onSuccess: () => resolve(),
      onError: (error) => reject(error),
    });
  });
};

const NotesTableWithActions: React.FC<TProps> = ({
  notes,
  pagination,
  saveNote,
  handleChangeStatus,
  handleDeleteNote,
  isAllowedChangeStatusAndRemoveActions = false,
}) => {
  const [note, setNote] = useState("");

  const handleSaveNote = async () => {
    try {
      await saveNote(note);
      setNote("");
    } catch (error) {
      console.error("Error handle saveNote", error);
    }
  };

  return (
    <Box border="1px solid rgba(0,0,0,.2)" borderRadius="10px" padding="7px">
      <Box display="flex" alignItems="center">
        <TextField
          data-test="new-note-input"
          size="small"
          fullWidth
          multiline
          label="Note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          sx={{ marginRight: "7px" }}
        />
        <Button data-test="add-note-button" onClick={handleSaveNote}>
          Add
        </Button>
      </Box>

      <TableData
        report={notes}
        handleDeleteNote={handleDeleteNote}
        handleChangeStatus={handleChangeStatus}
        isAllowedChangeStatusAndRemoveActions={isAllowedChangeStatusAndRemoveActions}
      />

      <PaginationWithLimit
        count={pagination.count}
        limit={pagination.limit}
        page={pagination.page}
        setPageState={pagination.setPage}
        setLimit={pagination.setLimit}
      />
    </Box>
  );
};

export default NotesTableWithActions;
